module.exports = __webpack_public_path__ + "assets/BackBT-ce1746.svg";